import {
    Box,
    Divider,
    Flex,
    Input,
    FormControl,
    FormErrorMessage,
    FormLabel,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useToast
} from '@chakra-ui/react'
import React from 'react'
import { useState } from 'react'
import axios from 'axios'
import { Auth } from './Auth'
import * as Yup from "yup";
import { useFormik } from "formik";


const ShippingAddress = ({ onClose, shippingArea, shippingId, partyId, addressChangeRender, orderData }) => {

    const [shippingData, setShippingData] = useState({
        firstName: shippingArea?.firstName,
        lastName: shippingArea?.lastName,
        phone: shippingArea?.phone,
        countryCode: shippingArea?.countryCode,
        city: shippingArea?.city,
        state: shippingArea?.state,
        district: shippingArea?.district,
        pincode: shippingArea?.pincode,
        country: shippingArea?.country,
        addressline1: shippingArea?.addressline1,
        addressline2: shippingArea?.addressline2
    })

    const toast = useToast()

    // const handleChange = (e) => {
    //     setShippingData({ ...shippingData, [e.target.name]: `${e.target.value}` })
    // }

    const orderSchema = Yup.object({
        firstName: Yup.string().required("Please enter the first name"),
        lastName: Yup.string().required("Please enter the last name"),
        phone: Yup.string().required("Please enter 10 digit mobile number").matches(/^[0-9]+$/, "Must be only digits").min(10, 'Must be exactly 10 digits').max(10, 'Must be exactly 10 digits'),
        city: Yup.string().required("Please enter the city name"),
        // countryCode:Yup.number(),
        state: Yup.string().required("Please enter the state"),
        district: Yup.string().required("Please enter the state"),
        pincode: Yup.string().required("Please enter the pincode").matches(/^[0-9]+$/, "Must be only digits").min(6, 'Must be exactly 6 digits').max(6, 'Must be exactly 6 digits'),
        country: Yup.string().required("Please enter the country"),
        addressline1: Yup.string().required("Please enter the complete address"),
        addressline2: Yup.string(),
    })

    const updateAddress = () => {
        let data = JSON.stringify({
            "partyId": `${partyId}`,
            "addressId": `${shippingId}`,
            "addressParams": {
                "firstName": `${shippingData.firstName}`,
                "lastName": `${shippingData.lastName}`,
                "phone": `${shippingData.phone}`,
                "addressline1": `${shippingData.addressline1}`,
                "addressline2": `${shippingData.addressline2}`,
                "city": `${shippingData.city}`,
                "state": `${shippingData.state}`,
                "district": `${shippingData.district}`,
                "country": `${shippingData.country}`,
                "countryCode": `${shippingData.countryCode}`,
                "pincode": `${shippingData.pincode}`,
                "partyId": `${partyId}`
            }
        });

        let config = {
            method: 'patch',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/party/address`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Auth()
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                toast({
                    title: 'Shipping Address Updated',
                    position: 'top',
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })

                let data3 = JSON.stringify({
                    "orderId": `${orderData.id}`,
                    "isAutoVerified": orderData.isAutoVerified,
                    "orderGstNumber": orderData.orderGstNumber !== null ? orderData.orderGstNumber : 'n/a: Gst was not provided while creating order',
                    "reqType": "PUT",
                    "draftOrderId": orderData?.draftOrderId
                  });
            
                  let config3 = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/shopify/sync-draft-order`,
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': Auth()
                    },
                    data: data3
                  };
            
                  axios.request(config3)
                    .then((response) => {
                    console.log('syn-put-updated')
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                addressChangeRender()
                onClose()
            })
            .catch((error) => {
                console.log(error);
                toast({
                    title: 'Oops we are facing some temporary issue with your request',
                    position: 'top',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                })
                onClose()
            });
    }


    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
       initialValues: shippingData,
      validationSchema: orderSchema,
      onSubmit:updateAddress,
    })


    return (
        <ModalContent>
            <ModalHeader textAlign={'center'}>Edit Shipping Address</ModalHeader>
            <ModalCloseButton onClick={onClose} />
            <Divider borderColor={'black'} />
            <ModalBody>
                <Flex width={'full'} justifyContent={'space-between'}>
                    <Box flexBasis={'48%'}>
                        <FormControl mt={4} isInvalid={errors.firstName && touched.firstName} >
                            <FormLabel>First Name</FormLabel>
                            <Input placeholder='Enter your first name' value={values.firstName} onChange={handleChange} onBlur={handleBlur} name='firstName' autoComplete="off" />
                            {errors.firstName && touched.firstName ? (
                                <FormErrorMessage>{errors.firstName}</FormErrorMessage>
                                ) : null}
                        </FormControl>

                        <FormControl mt={4} isInvalid={errors.lastName && touched.lastName} >
                            <FormLabel>Last Name</FormLabel>
                            <Input placeholder='Enter your last name' value={values.lastName} onChange={handleChange} onBlur={handleBlur} name='lastName' autoComplete="off" />
                            {errors.lastName && touched.lastName ? (
                                <FormErrorMessage>{errors.lastName}</FormErrorMessage>
                                ) : null}
                        </FormControl>

                        <FormControl mt={4} isInvalid={errors.phone && touched.phone}>
                            <FormLabel>Phone No.</FormLabel>
                            <Input placeholder='Enter your contact no.' value={values.phone} onChange={handleChange} onBlur={handleBlur} name='phone' autoComplete="off" />
                            {errors.phone && touched.phone ? (
                                <FormErrorMessage>{errors.phone}</FormErrorMessage>
                                ) : null}
                        </FormControl>

                        <FormControl mt={4} isInvalid={errors.countryCode && touched.countryCode}>
                            <FormLabel>Country Code</FormLabel>
                            <Input placeholder='Enter your country code (for india - +91)' value={values.countryCode} onChange={handleChange} onBlur={handleBlur} name='countryCode' autoComplete="off" />
                            {errors.countryCode && touched.countryCode ? (
                                <FormErrorMessage>{errors.countryCode}</FormErrorMessage>
                                ) : null}
                        </FormControl>
                    </Box>

                    <Box flexBasis={'48%'}>

                        <FormControl mt={4} isInvalid={errors.city && touched.city}>
                            <FormLabel>City</FormLabel>
                            <Input placeholder='Enter your city name' name='city' value={values.city} onChange={handleChange} onBlur={handleBlur} autoComplete="off" />
                            {errors.city && touched.city ? (
                                <FormErrorMessage>{errors.city}</FormErrorMessage>
                                ) : null}
                        </FormControl>

                        <FormControl mt={4} isInvalid={errors.state && touched.state} >
                            <FormLabel>State</FormLabel>
                            <Input placeholder='Enter your state name' value={values.state} onChange={handleChange} onBlur={handleBlur} name='state' autoComplete="off" />
                            {errors.state && touched.state ? (
                                <FormErrorMessage>{errors.state}</FormErrorMessage>
                                ) : null}
                        </FormControl>

                        <FormControl mt={4} isInvalid={errors.district && touched.district} >
                            <FormLabel>District</FormLabel>
                            <Input placeholder='Enter your district name' value={values.district} onChange={handleChange} onBlur={handleBlur} name='district' autoComplete="off" />
                            {errors.district && touched.district ? (
                                <FormErrorMessage>{errors.district}</FormErrorMessage>
                                ) : null}
                        </FormControl>

                        <FormControl mt={4} isInvalid={errors.pincode && touched.pincode} >
                            <FormLabel>Pin Code</FormLabel>
                            <Input placeholder='Enter your pin code' value={values.pincode} onChange={handleChange} onBlur={handleBlur} name='pincode' autoComplete="off" />
                            {errors.pincode && touched.pincode ? (
                                <FormErrorMessage>{errors.pincode}</FormErrorMessage>
                                ) : null}
                        </FormControl>

                    </Box>
                </Flex>
                <Box>
                    <FormControl mt={4} isInvalid={errors.country && touched.country}>
                        <FormLabel>Country</FormLabel>
                        <Input placeholder='Enter your country name' value={values.country} onChange={handleChange} onBlur={handleBlur} name='country' autoComplete="off" />
                        {errors.country && touched.country ? (
                                <FormErrorMessage>{errors.country}</FormErrorMessage>
                                ) : null}
                    </FormControl>

                    <FormControl mt={4} isInvalid={errors.addressline1 && touched.addressline1}>
                        <FormLabel>Address Line 1</FormLabel>
                        <Input placeholder='Enter your address line 1' value={values.addressline1} onChange={handleChange} onBlur={handleBlur} name='addressline1' autoComplete="off" />
                        {errors.addressline1 && touched.addressline1 ? (
                                <FormErrorMessage>{errors.addressline1}</FormErrorMessage>
                                ) : null}
                    </FormControl>

                    <FormControl mt={4} isInvalid={errors.addressline2 && touched.addressline2}>
                        <FormLabel>Address Line 2</FormLabel>
                        <Input placeholder='Enter your address line 2' value={values.addressline2} onChange={handleChange} onBlur={handleBlur} name='addressline2' autoComplete="off" />
                        {errors.addressline2 && touched.addressline2 ? (
                                <FormErrorMessage>{errors.addressline2}</FormErrorMessage>
                                ) : null}
                    </FormControl>
                </Box>

            </ModalBody>

            <ModalFooter>
                <Button colorScheme='red' mr={3} onClick={onClose}>
                    Cancel
                </Button>
                <Button colorScheme='whatsapp' onClick={handleSubmit} mr={3}>
                    Save Changes
                </Button>
            </ModalFooter>
        </ModalContent>
    )
}

export default ShippingAddress